  import Vue from 'vue'
  import Vuex from 'vuex'
  import createPersistedState from "vuex-persistedstate"
  Vue.use(Vuex)
  
  const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        userStatus: {},
    },
    mutations: {
      //所有mutations中的方法的第一个参数一定是state变量，用来进行对state中的状态的操作
      //第二个参数是可选参数，用于调用该 mutations 方法的时候传参
      setUser(state,data){
               state.userStatus=data;
         }
    }
  })
  
  export default store